import { Center, Flex, Image, Stack, Text, Title } from '@mantine/core';
import React from 'react';
import Button from '../../components/elements/Button';
import IconAdd from '../../components/icons/IconAdd';
import PropTypes from 'prop-types';

const EmptyState = ({ title, desc, txtBtn, handleAdd }) => {
  return (
    <Stack ta="center">
      <Center>
        <Image height={190} src={'../../assets/illu-notfound-reason-list.svg'} width={220}/>
      </Center>
      <div>
        <Title order={6}>{title}</Title>
        <Text>{desc}</Text>
      </div>
      <Button onClick={handleAdd} style="outlined">
        <Flex align="center" gap="xs" justify="center">
          <IconAdd/> {txtBtn}
        </Flex>
      </Button>
    </Stack>
  );
};

export default EmptyState;

EmptyState.propTypes = {
  desc: PropTypes.string,
  handleAdd: PropTypes.func,
  title: PropTypes.string,
  txtBtn: PropTypes.string
};
